import trackClick from 'js/utils/trackClick';
import { checkbox, radio } from './helpers';
import React, { useState } from 'react';
import { AnswerType } from './types';
import {
  Choice,
  ChoiceText,
  OtherTextInput,
  ChoiceSelector,
} from './styles/PingAnswerStyles';

type PingAnswerProps = {
  answerType: AnswerType;
  selected: boolean;
  onClick: () => void;
  text: string;
  otherTextInput: boolean;
  tagType: string;
  customAnswer?: string | null;
  setCustomText?: (text: string) => void;
};

export const PingAnswer: React.FC<PingAnswerProps> = ({
  answerType,
  selected,
  onClick,
  text,
  otherTextInput,
  tagType,
  setCustomText,
  customAnswer,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Choice
      className="u-clickable"
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      style={hovered ? { background: 'rgba(176, 137, 32, 0.1)' } : {}}
    >
      <ChoiceSelector>
        {answerType === AnswerType.checkbox
          ? checkbox(selected)
          : radio(selected)}
      </ChoiceSelector>
      {otherTextInput && setCustomText ? (
        <OtherTextInput
          onChange={(e) => setCustomText(e.target.value)}
          placeholder={text}
          onClick={() => {
            onClick();
            trackClick({
              source: 'cute-pings-v2-other-answer',
              extra: { tagType: tagType },
            });
          }}
          value={customAnswer ? customAnswer : ''}
        />
      ) : (
        <ChoiceText>{text}</ChoiceText>
      )}
    </Choice>
  );
};
